import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';
import { sortByNewest } from '../utils/sortByNewest';

export const fetchAuditLogs = createAsyncThunk('auditLogs/fetchMany', async (params) => {
    const response = await api.get('/audit-logs', { params });
    return response.data;
});

export const fetchAuditLogActions = createAsyncThunk('auditLogs/fetchActionsMany', async () => {
    const response = await api.get('/audit-logs/actions');
    return response.data;
});

export const fetchAuditLogWithRelated = createAsyncThunk('auditLogs/fetchWithRelated', async (logId) => {
    const response = await api.get(`/audit-logs/${logId}/related`);
    return response.data;
});

const Slice = createSlice({
    name: 'auditLogs',
    initialState: {
        list: [],
        actions: {},
        pagination: {
            currentPage: 1,
            totalPages: 0,
            totalCount: 0,
            limit: 50,
            hasMore: false
        },
        status: 'idle',
        error: null,
        // Selected audit log detail panel state
        selectedLog: null,
        relatedLogs: {
            sameResource: [],
            sameSession: [],
            impersonationChain: []
        },
        selectedStatus: 'idle',
        selectedError: null,
    },
    reducers: {
        clearSelectedLog: (state) => {
            state.selectedLog = null;
            state.relatedLogs = {
                sameResource: [],
                sameSession: [],
                impersonationChain: []
            };
            state.selectedStatus = 'idle';
            state.selectedError = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAuditLogActions.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAuditLogActions.fulfilled, (state, action) => {
                state.status = 'success';
                state.actions = action.payload;
                state.error = null;
            })
            .addCase(fetchAuditLogActions.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message || 'An error occurred';
            })

            .addCase(fetchAuditLogs.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAuditLogs.fulfilled, (state, action) => {
                state.status = 'success';
                state.list = sortByNewest(action.payload.data || action.payload);
                state.pagination = action.payload.pagination || state.pagination;
                state.error = null;
            })
            .addCase(fetchAuditLogs.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message || 'An error occurred';
            })

            // Fetch single audit log with related logs
            .addCase(fetchAuditLogWithRelated.pending, (state) => {
                state.selectedStatus = 'loading';
            })
            .addCase(fetchAuditLogWithRelated.fulfilled, (state, action) => {
                state.selectedStatus = 'success';
                state.selectedLog = action.payload.auditLog;
                state.relatedLogs = action.payload.relatedLogs;
                state.selectedError = null;
            })
            .addCase(fetchAuditLogWithRelated.rejected, (state, action) => {
                state.selectedStatus = 'failed';
                state.selectedError = action.error.message || 'An error occurred';
            });
    },
});

export const { clearSelectedLog } = Slice.actions;
export default Slice.reducer;
